import FakeSearchForm from '@/features/searchV2/modules/FakeSearchForm/FakeSearchForm';
import { classnames } from '@/helpers';
import useMobileView from '@/hooks/useMobileView';
import { _t, getLang } from '@/locale';

type HeroProps = {
  searchbarContainerRef: React.RefObject<HTMLDivElement>;
  showSearchbar: boolean;
};

const Hero = (props: HeroProps) => {
  const { isMobileView } = useMobileView();
  const selectedLang = getLang();

  return (
    <div className={classnames('align-center relative flex h-[250px] flex-col justify-end md:h-[394px]')}>
      <picture>
        <source srcSet="/images/desktop-homepage-background-2xl-v7.jpg" media="(min-width: 1900px)" />
        <source srcSet="/images/desktop-homepage-background-lg-v7.jpg" media="(min-width: 768px)" />
        <img
          src="/images/mobile-homepage-background-v7.jpg"
          className="absolute inset-0 h-full w-full bg-[#ddd2e1] object-cover"
          alt=""
          loading="eager"
          fetchPriority="high"
        />
      </picture>

      <div className="container relative z-10 mx-auto">
        <div className={classnames(!isMobileView ? 'mx-auto max-w-5xl pb-11 pt-20 md:pb-24' : '')}>
          <h1
            className={classnames(
              'md:mb-xxl !mt-0 text-2xl font-semibold text-white md:text-5xl',
              isMobileView
                ? 'max-w-[320px] p-0'
                : `mx-auto ${selectedLang === 'fi' ? 'max-w-[650px]' : 'max-w-[500px]'} text-center`,
            )}>
            {_t(`bokadirektH1.${isMobileView ? 'mobile' : 'desktop'}`)}
          </h1>
          <div className={classnames(isMobileView ? 'pt-lg pb-xxl' : 'mx-auto max-w-screen-md')}>
            <div ref={props.searchbarContainerRef}></div>
            {props.showSearchbar ? <FakeSearchForm /> : <div className="h-[52px]" />}
          </div>
        </div>
      </div>
      <div className="absolute inset-0 bg-black opacity-30 "></div>
    </div>
  );
};

export default Hero;
